import { post } from '../Services/http';
import {
  PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  PRODUCTS_SET_LIST_TYPE,
  PRODUCTS_SET_IS_LOADING,
} from '../constants';

export const setListType = (listType) => {
  // Fire and forget
  post(`/api/productsview/setListType?listType=${listType}`);

  return {
    type: PRODUCTS_SET_LIST_TYPE,
    payload: {
      listType,
    },
  };
};

export const receiveProductsWrapper = (productsWrapper) => ({
  type: PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  payload: {
    productsWrapper,
  },
});

export const setProductsLoading = (isLoading) => ({
  type: PRODUCTS_SET_IS_LOADING,
  payload: {
    isLoading,
  },
});
